var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { strMark } from '../Theme';
export var QueryParams = function (WrappedComponent) {
    var WithQueryParams = function (props) {
        var _a = useState(), queryParams = _a[0], setQueryParamas = _a[1];
        useEffect(function () {
            var cokieMark = getCookie('X-Mark');
            var query = queryString.parse(window.location.search);
            var temp = __assign({}, query);
            temp[strMark] = cokieMark;
            setQueryParamas(temp);
        }, []);
        return (React.createElement(WrappedComponent, __assign({}, props, { queryParams: queryParams })));
    };
    return withRouter(WithQueryParams);
};
export default QueryParams;
var getCookie = function (name) {
    var cookieString = document.cookie;
    var parts = cookieString.split('; ');
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        var _a = part.split('='), key = _a[0], value = _a[1];
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/QueryParams.tsx
// module id = 100
// module chunks = 0